<template>
  <div class="summaryList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @settleChange="settleChange"
      @productChange="productChange"
    ></SiruiSearch>
    <div class="main-content">
      <vxe-toolbar
        v-if="menuButtonList.length > 0"
        ref="VxeToolbar"
        :data="tableData"
        size="mini"
        :id="$route.path"
      >
        <template v-slot:buttons>
          <template v-for="(item, i) in menuButtonList">
            <vxe-button
              v-if="item.type == '0'"
              type="primary"
              :icon="item.attributes.buttonStyle"
              :key="i"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="siruiTable"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
        column-min-width="120"
        :loading="load"
        show-footer
        highlight-current-row
        :footer-method="footerMethod"
        @handleSelectionChange="handleSelectionChange"
        :max-height="$store.state.app.tableHeight"
        @cell-dblclick="dblclickEvent"
      >
      </vxe-grid>
    </div>
    <detail ref="dialog" @updateTableData="updateTableData" />
    <!-- 详情 -->
  </div>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/settle';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import detail from './detail';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'summaryList',
    components: {
      SiruiSearch,
      // inputNumberAd,
      detail,
    },
    data() {
      return {
        heightNew: 0,
        multipleSelection: [],
        menuButtonList: [],
        tableData: [],
        load: false,
        query: {
          summaryCompanyNo: null,
          summaryDepartmentNo: null,
          orderNo: null,
          settleNo: null,
          settleDesc: null,
          supplierNo: null,
          settleType: null,
          productNo: null,
          productDesc: null,
          settleCreateDateStart: null,
          settleCreateDateEnd: null,
        },
        companyList: [],
        departmentList: [],
        dataKey: [
          'purchaseContractDetailList',
          'businessInboundDetailList',
          'salesContractDetailList',
          'storageLadingPickingList',
          'fundPaymentList',
          'fundCollectionList',
          'expenseDetailList',
          'fundInterestList',
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            // 公司
            prop: 'summaryCompanyNo',
            name: this.$t('summaryList.search.summaryCompanyNo'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 事业部门
            prop: 'summaryDepartmentNo',
            name: this.$t('summaryList.search.summaryDepartmentNo'),
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 业务订单
            prop: 'orderNo',
            name: this.$t('summaryList.search.orderNo'),
            type: 'searchTableSpec',
            searchType: 'businessOrder',
            isMultiple: true,
          },
          {
            // 结算批次编号
            prop: 'settleNo',
            name: this.$t('summaryList.search.settleNo'),
            type: 'searchTableSpec',
            searchType: 'settle',
            isMultiple: true,
            currentValue: this.query.settleNo,
            changeMethod: 'settleChange',
          },
          {
            // 结算批次描述
            prop: 'settleDesc',
            name: this.$t('summaryList.search.settleDesc'),
            type: 'searchTableSpec',
            searchType: 'settle',
            isMultiple: true,
            currentValue: this.query.settleDesc,
            changeMethod: 'settleChange',
          },
          {
            // 供应链主体
            prop: 'supplierNo',
            name: this.$t('summaryList.search.supplierNo'),
            type: 'searchTableSpec',
            searchType: 'supplychain',
            isMultiple: true,
          },
          {
            // 结算类型
            prop: 'settleType',
            name: this.$t('summaryList.search.settleType'),
            type: 'dict',
            dictType: 'settle_type',
          },
          {
            // 商品编码
            prop: 'productNo',
            name: this.$t('summaryList.search.productNo'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productNo,
            changeMethod: 'productChange',
          },
          {
            // 商品描述
            prop: 'productDesc',
            name: this.$t('summaryList.search.productDesc'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            currentValue: this.query.productDesc,
            changeMethod: 'productChange',
          },
          {
            prop: 'settleCreateDateStart',
            name: this.$t('summaryList.search.settleCreateDateStart'),
            type: 'startDaterangePicker',
          }, // 创建日期起
          {
            prop: 'settleCreateDateEnd',
            name: this.$t('summaryList.search.settleCreateDateEnd'),
            type: 'endDaterangePicker',
          }, // 创建日期止
        ];
      },
      columnList() {
        return [
          { field: 'index', title: this.$t('table.index'), width: 60, fixed: 'left' }, // 序号
          { field: 'summaryCompanyName', title: this.$t('summaryList.table.summaryCompanyName') }, // 公司
          {
            field: 'summaryDepartmentName',
            title: this.$t('summaryList.table.summaryDepartmentName'),
          }, // 事业部门
          { field: 'orderNo', title: this.$t('summaryList.table.orderNo') }, // 业务订单
          { field: 'settleNo', title: this.$t('summaryList.table.settleNo') }, // 结算批次编号
          { field: 'settleDesc', title: this.$t('summaryList.table.settleDesc') }, // 结算批次描述
          {
            field: 'slipStatus',
            title: this.$t('summaryList.table.slipStatusName'),
            formatter: this.formatterStatus,
          }, // 结算单状态
          {
            // 发货数量
            field: 'deliveryQuantity',
            title: this.$t('summaryList.table.deliveryQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.deliveryQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 开单数量
            field: 'ladingQuantity',
            title: this.$t('summaryList.table.ladingQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.ladingQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 可开单库存数量
            field: 'availableLadingQuantity',
            title: this.$t('summaryList.table.availableLadingQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.availableLadingQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 未执行销售合同数量
            field: 'unexecutedSalesContractQuantity',
            title: this.$t('summaryList.table.unexecutedSalesContractQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.unexecutedSalesContractQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 可售库存数量
            field: 'availableSalesStorageQuantity',
            title: this.$t('summaryList.table.availableSalesStorageQuantity'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.availableSalesStorageQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            // 已付货款
            field: 'payedGoodsAmount',
            title: this.$t('summaryList.table.payedGoodsAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.payedGoodsAmount)}</span>];
              },
            },
          },
          {
            // 已付费用
            field: 'payedExpenseAmount',
            title: this.$t('summaryList.table.payedExpenseAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.payedExpenseAmount)}</span>];
              },
            },
          },
          {
            // 基准税率
            field: 'benchmarkRate',
            title: this.$t('summaryList.table.benchmarkRate'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.benchmarkRate, this.$globalVar.tPoint)}
                  </span>,
                ];
              },
            },
          },
          {
            // 税差
            field: 'taxDifference',
            title: this.$t('summaryList.table.taxDifference'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.taxDifference)}</span>];
              },
              edit: ({ row }) => {
                return !row.settleNo
                  ? [
                      <input-number-ad
                        value={row.taxDifference}
                        clearable={true}
                        max={9999999999.99}
                        min={-9999999999.99}
                        onInput={(val) => this.chooseTable(val, row, 'taxDifference')}
                      ></input-number-ad>,
                    ]
                  : [<span>{this.$baseRequest.formatTableColumn(row.taxDifference)}</span>];
              },
            },
          },
          {
            // 应收利息
            field: 'receivableInterest',
            title: this.$t('summaryList.table.receivableInterest'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.receivableInterest)}</span>];
              },
              edit: ({ row }) => {
                return !row.settleNo
                  ? [
                      <input-number-ad
                        value={row.receivableInterest}
                        clearable={true}
                        max={9999999999.99}
                        min={-9999999999.99}
                        onInput={(val) => this.chooseTable(val, row, 'receivableInterest')}
                      ></input-number-ad>,
                    ]
                  : [<span>{this.$baseRequest.formatTableColumn(row.receivableInterest)}</span>];
              },
            },
          },
          {
            // 已售应收款
            field: 'soldReceivableAmount',
            title: this.$t('summaryList.table.soldReceivableAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.soldReceivableAmount)}</span>,
                ];
              },
            },
          },
          {
            // 已收款
            field: 'receivedAmount',
            title: this.$t('summaryList.table.receivedAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.receivedAmount)}</span>];
              },
            },
          },
          {
            // 已售未收
            field: 'soldUnreceivedAmount',
            title: this.$t('summaryList.table.soldUnreceivedAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.soldUnreceivedAmount)}</span>,
                ];
              },
            },
          },
          {
            // 结算批次保证金
            field: 'settleBatchMarginMoney',
            title: this.$t('summaryList.table.settleBatchMarginMoney'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.settleBatchMarginMoney)}</span>,
                ];
              },
            },
          },
          {
            // 已返保证金
            field: 'returnedMarginMoney',
            title: this.$t('summaryList.table.returnedMarginMoney'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.returnedMarginMoney)}</span>,
                ];
              },
            },
          },
          {
            // 剩余保证金
            field: 'restMarginMoney',
            title: this.$t('summaryList.table.restMarginMoney'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.restMarginMoney)}</span>];
              },
            },
          },
          {
            field: 'unpayedExpenseAmount',
            title: this.$t('summaryList.table.unpayedExpenseAmount'), // 应付未付费用
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.unpayedExpenseAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.unpayedExpenseAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'unpayedExpenseAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            field: 'soldDeliveryRate',
            title: this.$t('summaryList.table.soldDeliveryRate'), // 已售数量/发运数量
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.soldDeliveryRate,
                      this.$globalVar.iPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.soldDeliveryRate}
                    max={1}
                    min={0}
                    precision={this.$globalVar.iPoint}
                    onInput={(val) => this.chooseTable(val, row, 'soldDeliveryRate')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 结算批次利润
            field: 'settleBatchProfit',
            title: this.$t('summaryList.table.settleBatchProfit'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.settleBatchProfit)}</span>];
              },
            },
          },
          {
            // 已返利润
            field: 'returnedProfit',
            title: this.$t('summaryList.table.returnedProfit'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.returnedProfit)}</span>];
              },
            },
          },
          {
            // 剩余利润
            field: 'restProfit',
            title: this.$t('summaryList.table.restProfit'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.restProfit)}</span>];
              },
            },
          },
          {
            // 采购均价
            field: 'purchaseAvgPrice',
            title: this.$t('summaryList.table.purchaseAvgPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.purchaseAvgPrice,
                      this.$globalVar.pPoint
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'detainMarginMoneyPercent',
            title: this.$t('summaryList.table.detainMarginMoneyPercent'), // 理论应扣留保证金比例
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.detainMarginMoneyPercent,
                      this.$globalVar.iPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.detainMarginMoneyPercent}
                    max={999999999.999999}
                    min={0}
                    precision={this.$globalVar.iPoint}
                    onInput={(val) => this.chooseTable(val, row, 'detainMarginMoneyPercent')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 理论应扣留保证金
            field: 'detainMarginMoneyAmount',
            title: this.$t('summaryList.table.detainMarginMoneyAmount'),
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.detainMarginMoneyAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.detainMarginMoneyAmount}
                    clearable={true}
                    max={9999999999.99}
                    min={-9999999999.99}
                    onInput={(val) => this.chooseTable(val, row, 'detainMarginMoneyAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 可返保证金
            field: 'returnableMarginMoney',
            title: this.$t('summaryList.table.returnableMarginMoney'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.returnableMarginMoney)}</span>,
                ];
              },
            },
          },
          {
            // 库存金额
            field: 'storageAmount',
            title: this.$t('summaryList.table.storageAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.storageAmount)}</span>];
              },
            },
          },
          {
            field: 'serviceTariffing',
            title: this.$t('summaryList.table.serviceTariffing'), // 平台服务费利率
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.serviceTariffing,
                      this.$globalVar.iPoint
                    )}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.serviceTariffing}
                    max={999999999.999999}
                    min={0}
                    precision={this.$globalVar.iPoint}
                    onInput={(val) => this.chooseTable(val, row, 'serviceTariffing')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 平台服务费
            field: 'serviceAmount',
            title: this.$t('summaryList.table.serviceAmount'),
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.serviceAmount)}</span>];
              },
            },
          },
        ];
      },
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      getData() {
        //获取数据
        const params = this.setSearchParams();
        this.load = true;
        this.$axios.post(API.LIST_ORDER_SETTLE_SUMMARY, params).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data;
            this.tableData.map((item) => {
              item.serviceAmount = this.$cal.calCommon(
                item.serviceTariffing,
                item.deliveryQuantity,
                '*',
                'amount'
              ); // 平台服务费=平台服务费利率*发货数量
            });
            this.$nextTick(() => {
              this.calcSumRealTime(['serviceAmount']);
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      setSearchParams() {
        let params = { ...this.query };
        params.supplierNo = params.supplierNo ? params.supplierNo[0].supplierCode : null;
        params.orderNo = this.query.orderNo ? params.orderNo[0].orderNo : null;
        return params;
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      searchBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 切换公司
        this.query.summaryDepartmentNo = null;
        this.getDepartment(val.val);
      },
      settleChange(val) {
        this.searchTableChange(val.val, [{ val: 'settleNo' }, { val: 'settleDesc' }]);
      },
      productChange(val) {
        this.searchTableChange(val.val, [
          { val: 'productNo', getVal: 'productDetailCode' },
          { val: 'productDesc', getVal: 'detailProductDisplayName' },
        ]);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.query[item.val] = val[0][item.getVal];
            } else {
              this.query[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.query[item.val] = null;
          });
        }
      },
      chooseTable(val, row, prop) {
        row[prop] = val;
        if (prop == 'detainMarginMoneyPercent') {
          row.detainMarginMoneyAmount = this.batchAccMul([
            row.availableLadingQuantity,
            row.purchaseAvgPrice,
            this.$cal.calCommon(val, 100, '/'),
          ]); // 理论应扣留保证金=可开单库存数量*采购均价*理论保证金比例
          row.returnableMarginMoney = this.$cal.calCommon(
            row.restMarginMoney,
            row.detainMarginMoneyAmount,
            '-',
            'amount'
          ); // 可返保证金=剩余保证金-理论应扣留保证金
          this.calcSumRealTime(['detainMarginMoneyAmount', 'returnableMarginMoney']);
        } else if (prop == 'detainMarginMoneyAmount') {
          this.calcSumRealTime(['detainMarginMoneyAmount']);
        }
        if (row.settleNo) {
          // 已定义结算批次
          if (
            prop == 'unpayedExpenseAmount' ||
            prop == 'soldDeliveryRate' ||
            prop == 'serviceTariffing'
          ) {
            if (prop == 'soldDeliveryRate') {
              // 已售数量/发运数量
              if (val < 0.997) {
                row.storageAmount = this.$cal.calCommon(
                  row.availableLadingQuantity,
                  row.purchaseAvgPrice,
                  '*',
                  'amount'
                ); // 库存金额=可开单库存数量*采购均价
              } else {
                row.soldDeliveryRate = 1;
                row.storageAmount = 0;
              }
            }
            if (prop == 'serviceTariffing') {
              // 平台服务费利率
              row.serviceAmount = this.$cal.calCommon(val, row.deliveryQuantity, '*', 'amount'); // 平台服务费=平台服务费利率*发货数量
            }
            row.settleBatchProfit = this.calcHasSettleBatchProfit(row);
            row.restProfit = this.calcRestProfit(row);
            this.calcSumRealTime([
              'unpayedExpenseAmount',
              'soldDeliveryRate',
              'settleBatchProfit',
              'restProfit',
              'serviceAmount',
            ]);
          }
        } else {
          // 未定义结算批次
          if (prop == 'unpayedExpenseAmount' || prop == 'soldDeliveryRate') {
            if (prop == 'soldDeliveryRate') {
              // 已售数量/发运数量
              if (val < 0.997) {
                row.storageAmount = this.$cal.calCommon(
                  row.availableLadingQuantity,
                  row.purchaseAvgPrice,
                  '*',
                  'amount'
                ); // 库存金额=可开单库存数量*采购均价
              } else {
                row.soldDeliveryRate = 1;
                row.storageAmount = 0;
              }
            }
            this.calcSumRealTime(['unpayedExpenseAmount', 'soldDeliveryRate']);
          } else if (
            /* else if (prop == 'serviceTariffing') { // 平台服务费利率
          row.serviceAmount = this.$cal.calCommon(val, row.deliveryQuantity, '*', 'amount'); // 平台服务费=平台服务费利率*发货数量
          row.settleBatchProfit = this.calcNoSettleBatchProfit(row); //未定义结算批次 也要重新计算结算批次利润  by tengq 20/12/10
          row.restProfit = this.calcRestProfit(row);
          this.calcSumRealTime(['serviceAmount']);
        }  */
            prop == 'taxDifference' ||
            prop == 'receivableInterest' ||
            prop == 'serviceTariffing'
          ) {
            //未定义结算批次 也要重新计算结算批次利润  by tengq 20/12/10
            row.serviceAmount = this.$cal.calCommon(
              row.serviceTariffing,
              row.deliveryQuantity,
              '*',
              'amount'
            ); // 平台服务费=平台服务费利率*发货数量
            row.settleBatchProfit = this.calcNoSettleBatchProfit(row); //未定义结算批次 也要重新计算结算批次利润  by tengq 20/12/10
            row.restProfit = this.calcRestProfit(row);
            this.calcSumRealTime([
              'taxDifference',
              'settleBatchProfit',
              'restProfit',
              'receivableInterest',
              'serviceAmount',
            ]);
          }
        }
        this.updateData();
      },
      calcHasSettleBatchProfit(row) {
        // 已定义结算批次
        return this.batchAccSub(row.soldReceivableAmount, [
          this.$cal.calCommon(row.soldDeliveryRate, row.costWithTax, '*'),
          row.payedExpenseAmount,
          row.unpayedExpenseAmount,
          row.taxDifference,
          row.receivableInterest,
          row.serviceAmount,
        ]); // 结算批次利润=已售应收款-已售数量/发运数量*单批次的所有的含税成本-已付费用-应付未付费用-税差-应收利息-平台服务费
      },
      calcNoSettleBatchProfit(row) {
        // 未定义结算批次 (结算批次利润=-已付费用-税差-应收利息-平台服务费)  /修改公式减去平台服务费  by tengq 20/12/10
        return this.batchAccSub(-row.payedExpenseAmount, [
          row.taxDifference,
          row.receivableInterest,
          row.serviceAmount,
        ]);
      },
      calcRestProfit(row) {
        return this.$cal.calCommon(row.settleBatchProfit, row.returnedProfit, '-', 'amount'); // 剩余利润=结算批次利润-已返利润
      },
      chooseClick(type) {
        if (type == 'save') {
          this.save();
        } else if (type == 'export') {
          this.handleExport();
        } else if (type == 'create') {
          this.createSummary();
        }
      },
      updateTableData(rowItem) {
        let cutPaymentTotal = 0; //销售明细行总和
        rowItem.salesContractDetailList.map((item) => {
          let obj = JSON.parse(item.serializationJsonData);
          cutPaymentTotal = this.$cal.calCommon(cutPaymentTotal, obj.cutPayment, '+', 'amount');
        });
        // 已售应收款 = 已售应收款-销售明细行扣款总和 = 更新情况： 上次已售应收款 - 销售明细行扣款总和 + 上次扣款总和
        rowItem.soldReceivableAmount = this.$cal.calCommon(
          this.$cal.calCommon(rowItem.soldReceivableAmountInit, cutPaymentTotal, '-'),
          rowItem.cutPaymentTotalInit,
          '+',
          'amount'
        );
        // 已售未收 = 已售应收款-已收款
        rowItem.soldUnreceivedAmount = this.$cal.calCommon(
          rowItem.soldReceivableAmount,
          rowItem.receivedAmount,
          '-',
          'amount'
        );
        rowItem.settleBatchProfit = rowItem.settleNo
          ? this.calcHasSettleBatchProfit(rowItem)
          : this.calcNoSettleBatchProfit(rowItem);
        this.calcSumRealTime([
          'soldReceivableAmount',
          'settleBatchProfit',
          'restProfit',
          'soldUnreceivedAmount',
        ]);
        this.tableData.map((item) => {
          if (item.id == rowItem.id) {
            item = rowItem;
          }
        });
        this.$refs.siruiTable.updateFooter();
      },
      createSummary() {
        // 生成结算汇总表
        const params = this.setSearchParams();
        this.loading.startLoading();
        this.$axios.post(API.SETTLE_GENERATESUMMARY, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.tableData = res.data.data;
            this.tableData.map((item) => {
              item.serviceAmount = this.$cal.calCommon(
                item.serviceTariffing,
                item.deliveryQuantity,
                '*',
                'amount'
              ); // 平台服务费=平台服务费利率*发货数量
              // item.serviceAmount = this.$cal.calCommon(item.serviceTariffing, item.deliveryQuantity, '*', 'amount'); // 平台服务费=平台服务费利率*发货数量
            });
            this.$nextTick(() => {
              this.calcSumRealTime(['serviceAmount']);
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      save() {
        // 保存
        let tableData = [];
        [...this.exportData()].map((item) => {
          item.associationList = [];
          this.dataKey.map((it) => {
            if (item[it]) {
              item[it].map((i) => {
                item.associationList.push(i);
              });
            }
          });
          if (item.index != '小计') {
            tableData.push(item);
          }
        });
        this.$axios.post(API.SAVE_ORDERSETTLESUMMARY, tableData).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.getData();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      dblclickEvent(val) {
        // 双击进详情页面
        if (val.row.index != '小计') {
          this.resetsoldReceivableAmountInitData(val.row);
          this.$refs.dialog.openDialog(val.row);
        }
      },
      //重置计算已售应收款计算逻辑的初始数据
      resetsoldReceivableAmountInitData(row) {
        row['soldReceivableAmountInit'] = row.soldReceivableAmount; //将原始的已售应收款暂存，用于扣减销售明细中的扣款
        let cutPaymentTotal = 0;
        row.salesContractDetailList.map((item) => {
          let obj = JSON.parse(item.serializationJsonData);
          cutPaymentTotal = this.$cal.calCommon(cutPaymentTotal, obj.cutPayment, '+', 'amount');
        });
        row['cutPaymentTotalInit'] = cutPaymentTotal;
      },
      batchAccMul(muls) {
        // 批量乘
        let result = 1;
        muls.map((item) => {
          result = this.$cal.calCommon(result, item, '*');
        });
        return this.$cal.calCommon(result, 1, '*', 'amount');
      },
      batchAccSub(minuend, subtrahends) {
        // 批量减
        let result = minuend;
        subtrahends.map((item) => {
          result = this.$cal.calCommon(result, item, '-');
        });
        return this.$cal.calCommon(result, 0, '-', 'amount');
      },
      calcSumRealTime(props) {
        // 实时计算变化金额
        let tableData = this.exportData();
        props.map((item) => {
          let sum = 0;
          tableData.map((it) => {
            if (it.index == '小计') {
              it[item] = sum;
              sum = 0;
            } else {
              let type = 'amount';
              if (item.indexOf('Rate') != -1) {
                type = 'interest';
              }
              sum = this.$cal.calCommon(it[item], sum, '+', type);
            }
          });
        });
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'deliveryQuantity',
          'ladingQuantity',
          'availableLadingQuantity',
          'unexecutedSalesContractQuantity',
          'availableSalesStorageQuantity',
          'payedGoodsAmount',
          'payedExpenseAmount',
          'taxDifference',
          'receivableInterest',
          'soldReceivableAmount',
          'receivedAmount',
          'soldUnreceivedAmount',
          'settleBatchMarginMoney',
          'returnedMarginMoney',
          'restMarginMoney',
          'settleBatchProfit',
          'returnedProfit',
          'restProfit',
          'detainMarginMoneyAmount',
          'returnableMarginMoney',
          'storageAmount',
          'unpayedExpenseAmount',
          'serviceAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('batchAdd.fundsInterests.sumName');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                if (data[i].index != '小计') {
                  subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
                }
              }
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
      handleExport() {
        // 导出
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getSelectRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${baseUrl}${API.EXPORT_ORDERSETTLESUMMARY}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${baseUrl}${API.EXPORT_ORDERSETTLESUMMARY}?${params}&access_token=${this.token.access_token}`;
        }
      },
      updateData() {
        this.$refs.siruiTable.updateData();
      },
      exportData() {
        return this.$refs.siruiTable.getTableData().fullData;
      },
      formatterStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('slip_status', cellValue);
      },
      activeRowMethod({ row }) {
        if (row.index == '小计') {
          return false;
        }
        if (row.slipStatus == 'JSDZT06') {
          return false;
        }
        return true;
      },
    },
  };
</script>
